module.exports = __webpack_public_path__ + "img/back.28fa30de.jpg";